import Vue from 'vue'
import Vuex from 'vuex'

import { loginStore } from './login/loginStore'
import { listaPedidosStore } from './listaPedidosStore'
import { listaMunicipioStore } from './listaMunicipioStore'
import { listaLogradouroStore } from './listaLogradouroStore'
import { cartaoStore } from './cartaoStore'
import { SolicitacoesStore } from './login/SolicitacoesStore'


Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		breadCrumb: {
			tituloPagina: '',
			botoesAcao: { //botões de ação do cabeçalho
				salvar: false,
				novo: false,
				voltar: false
			},
			infoDadoSalvo: { //informação dentro da tarja verde ao salvar algum dado
				id: null,
				descricao: null
			}
		}
	},
	mutations: {
		setBreadCrumb(state, dados)
		{ //o primeiro param é sempre state
			state.breadCrumb = dados
		},
		setBreadCrumbInfoDadosSalvo(state, dados)
		{
			state.breadCrumb.infoDadoSalvo = dados
		},
	},
	actions: {
		setBreadCrumb({ commit }, dados)
		{
			commit('setBreadCrumb', dados)
		},
		setBreadCrumbInfoDadosSalvo({ commit }, dados)
		{
			commit('setBreadCrumbInfoDadosSalvo', dados)
		},
	},
	getters: {
		BreadCrumb: (state, getters) =>
		{
			return state.breadCrumb
		},
		getBreadCrumbInfoDadosSalvo: (state, getters) =>
		{
			return (state.breadCrumb.infoDadoSalvo || null)
		},
	},


	modules: { //Acrescentar todos os módulos aqui abaixo
		loginStore,
		cartaoStore,
		SolicitacoesStore,
		listaPedidosStore,
		listaMunicipioStore,
		listaLogradouroStore,


	}
})
